import styled from 'styled-components';

export const ConsultDoctorContainer = styled.div`
  border-top: ${(props) =>
    props.articleStrip ? 'none' : '7px solid transparent'};
  position: relative;
  padding: ${(props) =>
    props.isFertilityProduct ? '12px 8px 0 12px' : '16px 20px 10px'};
  border-bottom: ${(props) =>
    props.articleStrip ? 'none' : 'solid 1px #e5e5e5'};
  background-color: ${(props) =>
    props.isFertilityProduct
      ? '#ebf9fb'
      : props.articleStrip
        ? '#F6FAFA'
        : 'transparent'};
  margin: ${(props) => (props.isFertilityProduct ? '22px 12px' : '0 0 16px')};
  border-radius: ${(props) => (props.isFertilityProduct ? '8px' : '0')};
  border: ${(props) =>
    props.isFertilityProduct ? ' solid 1px rgba(0, 0, 0, 0.07)' : '0'};

  ::before {
    content: '';
    display: none;
    // display: ${(props) => (props.articleStrip ? 'none' : 'block')};
    position: absolute;
    width: 100%;
    height: 7px;
    background: linear-gradient(to right, #60afa5 0%, #8ccda8 100%);
    inset: 0;
  }

  h2 {
    margin: 0 0 5px;
    font-size: clamp(14px, 2vw, 20px);
    font-weight: 600;

    @media (min-width: 768px) {
      text-transform: none;
    }

    &.articleStrip {
      margin: 0 0 5px;
      font-size: clamp(12px, 2vw, 21px);
      font-weight: 600;
      color: #6e6e6e;
      text-transform: capitalize;
    }
  }

  span {
    font-size: clamp(12px, 2vw, 17px);
    font-weight: normal;
    color: #6e6e6e;
  }

  @media (min-width: 768px) {
    display: ${(props) => (props.articleStrip ? 'none' : 'block')};
    padding: ${(props) =>
      props.isFertilityProduct ? '14px 16px 0' : '16px 20px 10px'};
  }
`;

export const ConsultSection = styled.div`
  display: flex;
  align-items: ${(props) => (props.isFertilityProduct ? '' : 'center')};
  justify-content: space-between;
  margin-top: ${(props) => (props.isFertilityProduct ? '0px' : '12px')};

  .arrowSvg {
    margin-left: 2px;
    width: 12px;
    object-fit: contain;
    height: 12px;
    margin-top: 1px;
    @media (min-width: 768px) {
      width: 17px;
      height: 17px;
    }

    display: ${(props) => (props.isFertilityProduct ? 'none' : 'block')};
  }

  .whatsappIcon {
    margin-left: 2px;
    width: 15px;
    height: 15px;
    margin-top: 1px;
    @media (min-width: 768px) {
      width: 17px;
      height: 17px;
    }
  }

  .consultRight {
    flex-basis: 70%;

    @media (min-width: 768px) {
      flex-basis: 50%;
    }

    h2 {
      margin: 0 0 10px;
      font-size: clamp(14px, 2vw, 17px);
      font-weight: 600;

      @media (min-width: 768px) {
        margin-bottom: 7px;
      }
    }

    span {
      opacity: 0.87;
      color: black;
      font-weight: 600;
      font-size: clamp(10px, 2vw, 12px);
      margin: 12px 0;
      display: block;
      @media (min-width: 768px) {
        margin: 10px 0 24px;
      }
    }
  }

  .doctorImg {
    position: relative;
    padding-top: 30%;
    width: 25%;
    border-radius: 6px;

    img {
      border-radius: 6px;
    }

    @media (min-width: 768px) {
      padding-top: 21%;
      width: 17%;
    }
  }

  .pdpDoctorImg {
    position: relative;
    padding-top: 43%;
    width: 59%;
    border-radius: 6px;

    img {
      border-radius: 6px;
    }

    @media (min-width: 768px) {
      padding-top: 25%;
      width: 26%;
    }
  }

  button {
    background: ${(props) => (props.articleStrip ? 'transparent' : '#ef4e5e')};
    border: none;
    color: #ef4e5e;
    display: flex;
    align-items: center;
    font-size: clamp(12px, 2vw, 17px);
    padding: 8px 0;
    font-family: 'Montserrat';
    font-weight: 500;

    &.lowOpacity {
      opacity: 0.4;
    }

    margin-top: ${(props) => (props.isFertilityProduct ? '10px' : '0px')};
    @media (min-width: 768px) {
      cursor: pointer;
    }

    &.pdpButton {
      border-radius: 14px;
      color: white;
      padding: 8px 10px;
      font-size: clamp(10px, 2vw, 11px);
      position: relative;
      overflow: hidden;
      @media (min-width: 768px) {
        padding: 0px 10px;
      }

      span {
        position: absolute;
        opacity: 0;
        top: 0;
        left: 0;
        background: linear-gradient(
          105deg,
          rgb(239, 78, 94) 7%,
          rgb(255 255 255) 14%,
          rgb(250, 118, 131) 21%,
          rgb(239, 78, 94) 28%
        );

        width: 120%;
        height: 100%;
        animation: move_continue 2s;
        animation-iteration-count: infinite;
        animation-delay: 1s;
      }

      @keyframes move_continue {
        0% {
          left: 0;
          opacity: 0;
        }
        5% {
          opacity: 0;
        }
        48% {
          opacity: 0.2;
        }
        80% {
          opacity: 0;
        }
        100% {
          left: 82%;
        }
      }

      p {
        padding: ${(props) =>
          props.isFertilityProduct ? '10px 9px 10px 12px' : '0px'};
        font-size: ${(props) => (props.isFertilityProduct ? '14px' : '')};
      }

      margin-bottom: ${(props) => (props.isFertilityProduct ? '8px' : '0px')};

      @media (max-width: 720px) {
        p {
          padding: ${(props) =>
            props.isFertilityProduct ? '2px 10px' : '0px'};
          font-size: ${(props) => (props.isFertilityProduct ? '12px' : '')};
          font-weight: 700;
        }

        margin-bottom: ${(props) => (props.isFertilityProduct ? '6px' : '0px')};
      }
    }
  }

  .consultText {
    opacity: 0.87;
    font-size: ${(props) =>
      props.isFertilityProduct ? '14px' : 'clamp(12px, 2vw, 12px)'};
    font-weight: normal;
  }
`;

export const ConsultFormContainer = styled.div`
  border-top: ${(props) =>
    props.isConsultPage ? 'none' : '10px solid transparent'};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-image: linear-gradient(to right, #60afa5 0%, #8ccda8 100%) 1;
  padding: 16px;
  background-color: #fff;
  min-height: ${(props) => (props.isConsultPage ? '65vh' : 'unset')};

  .greeting {
    opacity: 0.87;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    margin: 16px 0px 10px;
  }

  span {
    display: block;
    opacity: 0.87;
    font-size: 12px;
    font-weight: normal;
    text-align: center;
    margin-bottom: 8px;
  }

  .circleImg {
    position: relative;
    margin: auto;
    width: 25%;
    padding-top: 25%;
  }

  .freeMsg {
    display: ${(props) => (props.isConsultPage ? 'none' : 'block')};
    font-size: 12px;
    color: #6e6e6e;
    text-align: left;
    margin: 8px 0;
  }
`;
export const FormInner = styled.div`
  width: 450px;
  margin: auto;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const RequestCallbackBtn = styled.button`
  width: 100%;
  margin: auto;
  overflow: hidden;
  padding: 12px 0;
  text-align: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  background: #ef4e5e;
  color: white;
  font-family: 'Montserrat';
  border: none;
  border-radius: 8px;
  margin-top: ${(props) => (props.isConsultPage ? '20px' : '12px')};
  font-size: 14px;
  font-weight: 500;
  position: relative;

  span {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    background-image: linear-gradient(
      110deg,
      #ef4e5e 4%,
      #ffd2d7 22%,
      #fa7683 30%,
      #ef4e5e 39%
    );
    width: 70%;
    height: 100%;
    animation: move_continue 2s;
    animation-iteration-count: infinite;
    animation-delay: 1s;
  }

  @keyframes move_continue {
    0% {
      left: 0;
      opacity: 0;
    }
    5% {
      opacity: 0;
    }
    48% {
      opacity: 0.2;
    }
    80% {
      opacity: 0;
    }
    100% {
      left: 82%;
    }
  }

  &.lowOpacity {
    opacity: 0.5;
  }
`;
export const LeadSubmitContainer = styled.div`
  width: 450px;
  margin: auto;
  margin-top: ${(props) => (props.isConsultPage ? '100px' : 'auto')};
  text-align: center;

  .details {
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    color: rgb(0, 0, 0, 0.87);
    padding: 16px 0;
  }

  .desc {
    font-size: 12px;
    text-align: center;
    color: rgb(0, 0, 0, 0.87);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const BookingWrapper = styled.div`
  display: flex;
  padding: ${(props) =>
    props.article || props.categoryPage
      ? '10px 0 0'
      : props.ovulation
        ? '0'
        : '22px 0'};
  gap: 9px;
  align-items: ${(props) => (props.ovulation ? 'center' : 'start')};

  p {
    opacity: 0.87;
    font-size: 12px;
    font-weight: normal;
    color: rgb(0, 0, 0, 0.87);
  }

  img {
    width: 25px;
  }

  @media (min-width: 768px) {
    p {
      font-size: ${(props) => (props.ovulation ? '18px' : '15px')};
    }
  }
`;

export const BottomSection = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-evenly;
  margin-bottom: 20px;

  .widgetContainer {
    text-align: center;
    flex-basis: 30%;
  }

  p {
    font-size: clamp(11px, 2vw, 13px);
    color: #6e6e6e;
    font-weight: normal;
    max-width: 110px;
    @media (min-width: 768px) {
      max-width: 140px;
    }
  }

  img {
    width: 36px;
    height: 36px;
    margin-bottom: 6px;
  }
`;

export const BottomText = styled.p`
  font-size: clamp(12px, 2vw, 14px);
  font-weight: 600;
  color: #6e6e6e;
  width: 90%;
  text-align: center;
  border-top: 1px solid #e5e5e5;
  padding-top: 20px;
  margin: 40px auto 30px;

  @media (min-width: 768px) {
    width: 100%;
  }
`;

export const BotContainer = styled.div`
  @media (min-width: 768px) {
    width: 450px;
  }
  margin: auto;
`;
